// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permissions_roles-container {
    width: 95%;
    margin: 9rem auto 0;
    max-height: calc(100vh - 15rem);
    overflow-y: auto;
    padding-right: 12px;
}

.permission_block {
    width: 100%;
    min-height: 5.4rem;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: .9rem 0;
    padding: 0 1rem;
}

    .permission_block h6 {
        border-right: 1px solid gray;
        width: 25rem;
        line-height: 1.3;
        font-size: 2rem;
        font-weight: bold;
        flex: 0 0 25rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 1rem;
    }

.permission-list {
    overflow: hidden;
    flex: 1;
    min-width: 0;
    padding-left: 1rem;
    word-break: break-word;
}

.permission-dialog-footer-container {
    display: flex;
    gap: 10px;
}

.permission-dialog-cancel {
    background-color: #d22e37;
}`, "",{"version":3,"sources":["webpack://./src/app/permission/permission-main/permission-tabs/permission-role-list/PermissionRoleList.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+GAA+G;IAC/G,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;IAEI;QACI,4BAA4B;QAC5B,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;;AAEJ;IACI,gBAAgB;IAChB,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".permissions_roles-container {\r\n    width: 95%;\r\n    margin: 9rem auto 0;\r\n    max-height: calc(100vh - 15rem);\r\n    overflow-y: auto;\r\n    padding-right: 12px;\r\n}\r\n\r\n.permission_block {\r\n    width: 100%;\r\n    min-height: 5.4rem;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    margin: .9rem 0;\r\n    padding: 0 1rem;\r\n}\r\n\r\n    .permission_block h6 {\r\n        border-right: 1px solid gray;\r\n        width: 25rem;\r\n        line-height: 1.3;\r\n        font-size: 2rem;\r\n        font-weight: bold;\r\n        flex: 0 0 25rem;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        padding-right: 1rem;\r\n    }\r\n\r\n.permission-list {\r\n    overflow: hidden;\r\n    flex: 1;\r\n    min-width: 0;\r\n    padding-left: 1rem;\r\n    word-break: break-word;\r\n}\r\n\r\n.permission-dialog-footer-container {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.permission-dialog-cancel {\r\n    background-color: #d22e37;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
